<template>
    <result-wrapper :element-data="elementData" flag-name="link-45deg-icon">
    <!-- The container row can arrive WITHOUT its `minisitelinksbox` payload: the fleet
         HTML parser emits a bare header row for this type (seen on browser-polled poll
         115240560, 2026-07-07, and on any reparse that takes the HTML path). Reading
         through it unguarded threw mid-render, and Vue then failed to reconcile the
         whole card — the visible symptom was a cascade of unmount/nextSibling errors,
         not this line. Render nothing when there is no payload. -->
    <div class="markup-container" v-if="elementData?.minisitelinksbox">
      <span class="card-title ellipsis">
        <favicon v-if="zoomSelection === 'regular-view'&& showFavicons"
          :url="elementData?.minisitelinksbox?.url" class="serp-favicon" />
        <span class="result-title" v-html="elementData.minisitelinksbox.title"></span>
      </span>
      <div class="ellipsis d-flex">
        <span class="me-1" v-if="'starrating' in elementData.minisitelinksbox">
          {{ formatRating }}
          <i class="bi bi-star-fill xs"></i>
        </span>
        <markup-link :resultData=elementData.minisitelinksbox
          :resultType="elementData.minisitelinksbox.resulttype" />
      </div>
    </div>
  </result-wrapper>
</template>

<script>
import MarkupLink from "@/components/card/MarkupLink.vue";
import ResultWrapper from "@/components/card/ResultWrapper.vue";
import commonUtil from "@/utils/commonUtil.js";
import Favicon from "@/components/Favicon.vue";
import { mapGetters } from "vuex";

export default {
  name: "MiniSiteLinksResult",
  props: {
    elementData: Object,
  },
  components: {
    MarkupLink,
    ResultWrapper,
    Favicon,
  },
  data() {
    return {
    }
  },
  computed: {
    formatRating() {
      // Guarded for the same reason as the template: the payload may be absent.
      const rating = this.elementData?.minisitelinksbox?.starrating;
      return rating ? commonUtil.formattedRating(rating.text, rating.value) : "";
    },
    ...mapGetters("toolbar", {
      zoomSelection: "zoomSelection",
      showFavicons: "showFavicons" 
    }),
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "@/scss/_icons.scss";

.xs {
  font-size: .75em;
  color: #FCD663;
  text-shadow: 0 0 2px #000;
}

.serp-favicon {
  margin-right: 0.25rem;
  display: inline-block;
  vertical-align: middle;
}

.result-title {
  vertical-align: middle;
}
</style>